import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { memes } from "@/mocks/memes";
import { formatHeat } from "@/utils/format";

const preview = memes.slice(0, 4);

export default function MemePreview() {
  return (
    <section className="mx-auto w-full px-4 py-16 md:px-6 md:py-20" aria-labelledby="meme-title">
      <Reveal>
        <SectionHeading
          eyebrow="表情包专区"
          title={<span id="meme-title">聊天没图了？先来这儿翻翻</span>}
          desc="每张表情包都标注了出处与使用场景，存下来就能直接用。"
          action={
            <Link
              to="/memes"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              打开全部图集
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          }
        />
      </Reveal>

      <div className="mt-10 grid grid-cols-2 gap-4 lg:grid-cols-4">
        {preview.map((meme, index) => (
          <Reveal key={meme.id} delay={index * 60}>
            <article className="group h-full overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <Link to="/memes" className="relative block aspect-square w-full overflow-hidden bg-background-100">
                <img
                  src={meme.image}
                  alt={`${meme.title} 表情包`}
                  title={`${meme.title} - 513吃瓜表情包`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
              </Link>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-950">{meme.title}</h3>
                <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-800">
                    {meme.categoryName}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-heart-3-line text-primary-500" aria-hidden="true"></i>
                    {formatHeat(meme.likes)}
                  </span>
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}